<template>
    <div class="card mx-6">
        <slot v-if="meta.total > 0" name="header"></slot>
        <div class="table-responsive" v-if="meta.total > 0">
            <table class="table align-items-center">
                <thead class="thead-light">
                    <tr>
                        <th scope="col">{{$t('support.tickets.id')}}</th>
                        <th
                            scope="col"
                            class="sort"
                            @click="onSort('title')"
                            data-sort="title"
                        >{{$t('support.tickets.title')}}</th>
                        <th
                            scope="col"
                            data-sort="status"
                            style="position: relative"
                            @click.self="statusDropdown = !statusDropdown"
                            v-click-outside="closeStatusDropdown"
                        >
                            <Dropdown
                                :items="statusItems"
                                v-model="statusDropdown"
                                @onSelect="onFilter"
                            />
                            {{$t('support.tickets.status')}}
                        </th>
                        <th
                            scope="col"
                            class="sort"
                            @click="onSort('created_at')"
                            data-sort="created_at"
                        >{{$t('support.tickets.created_at')}}</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody class="list">
                    <TicketItem
                        v-for="ticket in tickets.data"
                        :key="ticket.id"
                        :ticket="ticket"
                    />
                </tbody>
            </table>
            <div class="card-footer py-4 d-flex justify-content-between">
                <div v-if="meta.total" class="d-flex align-items-center">
                    <span>{{ metaStatus }}</span>
                </div>
                <base-pagination
                    class="mb-0"
                    v-if="meta.total"
                    :page-count="meta.last_page"
                    v-model="meta.current_page"
                    @input="onChangePage"
                    type="#525F7F"
                ></base-pagination>
            </div>
        </div>
        <Empty
            v-else
            class="my-6"
            :color="color"
            :icon="'fa-window-close'"
            @redirect="createNew"
            :button-label="$t('tickets.empty.button')"
        >
            <template #title><h1 class="font-weight-medium mb-0">{{$t('tickets.empty.title')}}</h1></template>
            <template #subtitle><p>{{$t('tickets.empty.subtitle')}}.</p></template>
        </Empty>
    </div>
</template>

<script>
import TicketItem from "./TicketItem";
import Dropdown from "../Common/Dropdown";
import BasePagination from "../../argon/components/BasePagination";
import Empty from "../Common/Empty";

export default {
    name: "TicketTable",
    components: {
        Dropdown,
        TicketItem,
        BasePagination,
        Empty
    },
    data() {
        return {
            filters: [],
            tickets: [],
            perPage: 5,
            column: "created_at",
            order: "ASC",
            statusDropdown: false
        };
    },
    props: {
        color: {
            type: Object,
            required: true
        }
    },
    methods: {
        getTickets() {
            this.$loading.show();
            window.axios
                .get(`/api/app/tickets`, {
                    params: {
                        per_page: this.perPage,
                        page: this.meta ? this.meta.current_page : 1,
                        column: this.column,
                        order: this.order,
                        filters: this.filters
                    }
                })
                .then(res => {
                    this.tickets = res.data;
                })
                .catch(err => console.error(err))
                .finally(() => this.$loading.close());
        },
        onChangePage(page) {
            this.meta.current_page = page;
            this.getTickets();
        },
        onSort(column) {
            this.column = column;
            this.order = this.order === "DESC" ? "ASC" : "DESC";
            this.getTickets();
        },
        onFilter(item) {
            this.closeStatusDropdown();
            this.closePaymentDropdown();

            if (!this.filters.length) {
                this.filters.push(item);

                return this.getTickets();
            }

            const filters = this.filters.map(filter => {
                if (filter.column === item.column) {
                    return item;
                }
                return filter;
            });

            this.filters = filters;
            this.getTickets();
        },
        closeStatusDropdown() {
            this.statusDropdown = false;
        },
        closePaymentDropdown() {
            this.paymentDropdown = false;
        },
        createNew() {
            this.$loading.show();
            window.location.href = "/app/tickets/create";
        }
    },
    computed: {
        language() {
            return this.$store.getters.LANGUAGE;
        },
        statusItems() {
            const t = "support.tickets.situation.";

            return [
                {
                    name: "Todos",
                    value: null,
                    column: "status"
                },
                {
                    name: this.$t(`${t}OPEN`),
                    value: "OPEN",
                    column: "status"
                },
                {
                    name: this.$t(`${t}WAITING_STUDENT`),
                    value: "WAITING_STUDENT",
                    column: "status"
                },
                {
                    name: this.$t(`${t}WAITING_OP`),
                    value: "WAITING_OP",
                    column: "status"
                },
                {
                    name: this.$t(`${t}CLOSED`),
                    value: "CLOSED",
                    column: "status"
                },
                {
                    name: this.$t(`${t}RESOLVED`),
                    value: "RESOLVED",
                    column: "status"
                },
                {
                    name: this.$t(`${t}IN_PROCESS`),
                    value: "IN_PROCESS",
                    column: "status"
                }
            ];
        },
        meta() {
            return this.tickets.meta;
        },
        metaStatus() {
            return this.meta
                ? ` ${this.$t("common.showing")} ${this.meta.from} ${this.$t(
                      "common.to"
                  )} 
                    ${this.meta.to} ${this.$t("common.of")} ${
                      this.meta.total
                  } ${this.$t("common.results")}`
                : "";
        }
    },
    mounted() {
        this.getTickets();
    }
};
</script>

<style>
</style>
